import React from "react";

const CRAFT_ITEMS = [
    "১০০% কুমিল্লার খাদি কটন",
    "ডাবল-স্টিচ ফিনিশিং",
    "প্রিমিয়াম মেটাল বাটন",
    "রং ও কোয়ালিটি অ্যাশিউরেন্স",
];

export default function Marquee() {
    return (
        <div className="bg-[#1A1715] text-[#F4EFE6] py-3 sm:py-4 overflow-hidden marquee-mask" data-testid="craft-marquee">
            <div className="animate-marquee flex whitespace-nowrap w-max">
                {[...CRAFT_ITEMS, ...CRAFT_ITEMS].map((t, i) => (
                            <span key={i} className="flex items-center text-xs sm:text-sm tracking-wide">
                                <span className="px-5 sm:px-6">{t}</span>
                        <span className="text-[#C49A45]">✦</span>
                    </span>
                ))}
            </div>
        </div>
    );
}
